import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconCircleError = ({ color = 'var(--color-accent-3)' }: IconProps): JSX.Element => (
    <div className="icon-block">
       <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="11" cy="11.5" r="11" fill={color}/>
<path d="M11 6.5C8.2379 6.5 6 8.75806 6 11.5C6 14.2621 8.2379 16.5 11 16.5C13.7419 16.5 16 14.2621 16 11.5C16 8.75806 13.7419 6.5 11 6.5ZM11 15.5323C8.7621 15.5323 6.96774 13.7379 6.96774 11.5C6.96774 9.28226 8.7621 7.46774 11 7.46774C13.2177 7.46774 15.0323 9.28226 15.0323 11.5C15.0323 13.7379 13.2177 15.5323 11 15.5323ZM11.8468 13.4355C11.8468 12.9718 11.4637 12.5887 11 12.5887C10.5161 12.5887 10.1532 12.9718 10.1532 13.4355C10.1532 13.9194 10.5161 14.2823 11 14.2823C11.4637 14.2823 11.8468 13.9194 11.8468 13.4355ZM10.1935 9.18145L10.3347 11.9234C10.3347 12.0444 10.4556 12.1452 10.5766 12.1452H11.4032C11.5242 12.1452 11.6452 12.0444 11.6452 11.9234L11.7863 9.18145C11.7863 9.04032 11.6855 8.91935 11.5444 8.91935H10.4355C10.2944 8.91935 10.1935 9.04032 10.1935 9.18145Z"
      fill="white"/>
</svg>
    </div>
);

export default IconCircleError;
